/* RESPONSIBLE TEAM: team-ai-agent */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { type Router } from '@ember/routing';
import { inject as service } from '@ember/service';
import type Transition from '@ember/routing/-private/transition';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneIssuesRoute extends Route {
  @service declare appService: AppService;
  @service declare router: Router;
  @service declare permissionsService: $TSFixMe;

  analytics = {
    section: 'standalone',
    place: 'issues',
  };

  reactEnabled() {
    return true;
  }

  async beforeModel(transition: Transition) {
    if (!this.appService.app.canSeeIncidentDetection) {
      this.router.transitionTo('apps.app.standalone.performance');
      return;
    }

    this.permissionsService.ensurePermissionWhenTransitioning('can_access_reporting', transition);
  }
}

export default ReactRoute(StandaloneIssuesRoute);
